import { FundingActivityStatus } from "../enums";
import { SystemColor, SystemColorsModel } from "../models";

export class FundingUtil {
  static getColorsByStatus(status: keyof typeof FundingActivityStatus): SystemColor {
    let colors = SystemColorsModel.ligthGreenColors(); 
    switch (status) {
      case "InTansit":
        colors = SystemColorsModel.lightBlueColor();
        break;
      case "Scheduled":
        colors = SystemColorsModel.lightGreyColors();
        break;  
      case "Withdrawal":
        colors = SystemColorsModel.lightRedColor();
        break;
    }
    return colors;
  }
}
